/**
 * Whether a pack-opening ceremony is on screen right now.
 *
 * A module-level flag rather than context because the two sides never share
 * a tree in a useful way: `MotOpenExperience` knows when the reveal is up,
 * and the wallet provider (mounted above the whole app) wants to know whether
 * its window-focus refresh is safe to run. Routing that through React would
 * mean a provider above the wallet provider for a single boolean.
 *
 * WHY THE WALLET CARES. A focus-triggered refresh is the one background read
 * that used to run during a reveal — Safari fires `focus` when the collector
 * comes back from a notification — and a 401 from it navigated the tab to the
 * login page, losing the card that was mid-flight. The refresh no longer
 * navigates on 401, but skipping it entirely while the ceremony is up also
 * keeps the wallet's `loading` toggle from re-rendering the overlay tree on
 * every tab switch.
 */
let ceremonyActive = false;

export function setCeremonyActive(active: boolean): void {
  ceremonyActive = active;
}

export function isCeremonyActive(): boolean {
  return ceremonyActive;
}
